import type { DeviceManifest } from '@rapoo/device-sdk'
import {
  baseChannel0To7,
  baseChildDeviceEnabled,
  createBaseScreenImageCapability,
} from './generate/capabilityPresets'
import { p8BaseLightBandEffects } from './generate/lightingPresets'

/**
 * ESPR8 设备清单
 **/
const rapooESPR8: DeviceManifest = {
  channel: ['china_cybercafe'],
  model: 'ESPR8',
  mainControl: 'ESPR8',
  type: 'base',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: 0x144e,
    currentPid: 0x144e,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 2,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
    ],
  },
  driver: 'VT_nrf54L_Base',
  baseDisplay: 'screen',
  ui: {
    assetsDir: 'manifests/ESPR8',
    colors: {
      series: [
        {
          name: 'common.products.ESPR8.Black_Purple_Green',
          value: '#7C3CDC',
          key: 'Black_Purple_Green',
        },
        {
          name: 'common.products.ESPR8.White_Black_Yellow',
          value: '#FFF04C',
          key: 'White_Black_Yellow',
        },
        {
          name: 'common.products.ESPR8.Raspberry_Pink',
          value: '#FF2558',
          key: 'Raspberry_Pink',
        },
        {
          name: 'common.products.ESPR8.Black_Gray_Green',
          value: '#A9DB32',
          key: 'Black_Gray_Green',
        },
        {
          name: 'common.products.ESPR8.Black_Gray_Orange',
          value: '#FF672E',
          key: 'Black_Gray_Orange',
        },
        {
          name: 'common.products.ESPR8.Gray_Black_Red',
          value: '#F21111',
          key: 'Gray_Black_Red',
        },
      ],
      current: 'Raspberry_Pink',
    },
    icon: 'Hardware-Wireframe-Base',
    overview: true,
  },
  capabilities: [
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: p8BaseLightBandEffects,
      },
    },
    createBaseScreenImageCapability({
      maxScreenSlots: 8,
      systemPages: [
        {
          slot: 0,
          kind: 'home',
          presetScreens: [
            { style: 0, asset: 'preset1.png' },
            { style: 1, asset: 'preset2.png' },
            { style: 2, asset: 'preset3.png' },
          ],
        },
      ],
    }),
    baseChannel0To7,
    baseChildDeviceEnabled,
  ],
  layout: {
    keys: [],
  },
}

export default rapooESPR8
